<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex xs12>          
            <v-card pa-0>              
              <v-divider></v-divider>
              <v-card-text class="">
                <v-form v-model="valid">
                  <v-layout row wrap>                        
                    <v-flex sm12 lg12>
                      <v-radio-group label="Type :" v-model="formModel.type" row>
                        <v-radio label="String"  :value="0"></v-radio>
                        <v-radio label="Array" :value="1"></v-radio>
                      </v-radio-group>
                      <v-text-field
                          label="Name"                                                  
                          v-model="formModel.key"
                          v-validate="'required'"
                          data-vv-name="key"     
                          :error-messages="errors.collect('key')"  
                          required
                      ></v-text-field>                      
                      <template v-if="formModel.type === 0">
                        <v-textarea
                          label="Value"                                                  
                          v-model="formModel.value"
                          v-validate="'required'"
                          data-vv-name="value"     
                          :error-messages="errors.collect('value')"  
                          required                          
                        ></v-textarea>
                      </template>                      
                      <template v-else-if="showTable">
                        <div class="v-table__overflow tabular">
                          <v-btn @click="newOption()" icon class="primary--text mb-2" style="position: absolute; right:15px; " ><v-icon>add</v-icon></v-btn>                                           
                          <v-data-table
                            v-bind:headers="arr.headers"
                            v-bind:items="formModel.value"
                            hide-actions class="elevation-1 tabular" 
                          >
                            <template slot="items" slot-scope="props" >
                              <td style="width:10px">{{props.item.id}}</td>
                              <td style="width:180px">
                                <v-text-field
                                  solo hide-details
                                  type="text"
                                  v-model="props.item.name"
                                  label="Name"                                      
                                ></v-text-field>                           
                              </td>
                              <td style="min-width:180px">
                                <v-text-field
                                  solo hide-details
                                  type="text"
                                  v-model="props.item.childs"
                                  label="Childs"                                      
                                ></v-text-field>                           
                              </td>                                                                                  
                              <td style="width:1%">                                    
                                <v-btn v-on:click="delOption(props)" icon class="pink--text" small>
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </td>   
                            </template>  
                          </v-data-table>
                        </div>  
                      </template>
                    </v-flex>
                    <div class="form-btn">
                      <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                      <v-btn v-else @click="save(isUpdate)" color="primary">Update</v-btn>                                                                    
                      <v-btn outline @click="clear">Clear</v-btn>
                    </div>  
                  </v-layout>                                                            
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/apps/admin/models/Settings';    
import moment from 'moment';
const  model = new Model();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        isEditing:true,
        isUpdate:false,
        id: null,
        nama:null,

        formModel: {          
          key   : null,
          value : null,
          type  : 0,
        },
        showTable : false,
        arr : { headers: [{text:'no', value:'id'},{text:'name', value:'name'},{text:'childs', value:'childs'}] },
        //countries: Countries,
        balance: [],    
        valid: true
    }),
   // created () {this.getParents()},    
    mounted () {      
      this.$watch(['formModel','type'].join('.'), (newType)=>{
        if(newType === 0){          
          this.formModel.value = '';
          this.showTable = false;
        } else if(newType === 1){
          this.formModel.value = [];
          this.showTable = true;
        }        
      });
      this.init();
    }, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                     
                    Object.assign(this.formModel, data === null ? {}:data); 
                    setTimeout(()=>{
                      this.formModel.value = data.value;
                      if(Array.isArray(this.formModel.value)){
                        this.formModel.value.forEach((item, i)=>{                          
                          if(item.childs &&  typeof(item.childs) == 'object'){                            
                            this.formModel.value[i].childs = JSON.stringify(item.childs);
                          }
                        });
                      }
                    }, 100);
                    //console.log(this.formModel.value);
                    //this.checking(data);
                });                                               
            }
            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = moment().valueOf();
            this.formModel.info = null;

            if(Array.isArray(this.formModel.value)){
              this.formModel.value.forEach((item,i) => {
                if(item.childs){
                  try {
                      this.formModel.value[i].childs = JSON.parse(item.childs);
                      console.log(JSON.parse(item.childs));                  
                      
                  } catch (e) {
                      this.formModel.value[i].childs = item.childs;
                  }                  
                }
              });
            }

            if( !this.errors.any() ) {
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.nama.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },    
        
        newOption(){
          this.formModel.value.push({id:(this.formModel.value.length+1), name:''});
        },

        delOption(props){            
          this.formModel.value.splice(props.index, 1);   
          //this.detail.splice(props.index, 1);   
        },
    }
}
</script>